import { Input as InputPrimitive, } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const Input = React.forwardRef(({ variant = "primary", className, ...props }, ref) => {
    return (React.createElement(InputPrimitive, { className: cn(`in-input--${variant}`, className), ref: ref, ...props }));
});
Input.displayName = "Input";
export { Input };
//# sourceMappingURL=input.js.map